module.exports = __webpack_public_path__ + "static/media/telegram-dark.c2a01eb7.svg";